<script setup lang="ts">
import { createInput } from '@formkit/vue'
import Toggle from './CreateInputBase/Toggle.vue'

const toggle = createInput(Toggle)
</script>

<template>
  <FormKit :type="toggle" size="large" />
</template>
